module.exports = __webpack_public_path__ + "static/media/q_of_spades2.e8275359.png";